import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { dateFormat } from "../../../../utils/date";
import { putField } from "../../../../utils/form";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.hc.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.hc.approveCode"), dataIndex: "approveCode", align: "center" }),
        createColumnDate({ title: () => i18n.global.t("model.hc.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("model.hc.refInform"),
            dataIndex: "refInform.approveCode",
            dataIndexValueObject: ({ record }) => {
                return [
                    record.refInform?.approveCode,
                    dateFormat({ text: record.refInform?.createDate, format: "DD/MM/YYYY" })
                ];
            },
            dataIndexValue: ({ record, column }) => {
                return column
                    .dataIndexValueObject({ record })
                    .filter(d => d)
                    .join(" ");
            },
            customRender: ({ record, column }) => {
                return (
                    <>
                        {column.dataIndexValueObject({ record }).map(d => (
                            <div>{d}</div>
                        ))}
                    </>
                );
            },
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh"),
            dataIndex: "products.refHaz.tradeNameTh",
            dataIndexValueObject: ({ record }) => {
                return record.products.map(d => [d.refInformProduct?.refHaz?.approveCode, d.refInformProduct?.refHaz?.tradeNameTh]);
            },
            dataIndexValue: ({ record, column }) => {
                return column
                    .dataIndexValueObject({ record })
                    .map(d => d.filter(d => d).join(" "))
                    .filter(d => d)
                    .join(", ");
            },
            customRender: ({ record, column }) => {
                return (
                    <>
                        {column
                            .dataIndexValueObject({ record })
                            .map(d => d.filter(d => d).map(d => <div>{d}</div>))
                            .map(d => (
                                <div>{d}</div>
                            ))}
                    </>
                );
            },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hc.refStatus"),
            dataIndex: "refStatus.value",
            customRender: ({ record }) => <div>{record.refStatus?.value}</div>,
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            align: "center",
            search: {
                name: "refStatus.id"
            }
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
